export const PREDEFINED_VIEWS = {
  PENDING_ACTION: 'pending_action',
  ALL_DEALS: 'all_deals',
};
